import { Dispatch } from 'redux';
import { APPEND_CLASS_TO_NAV } from '../../helpers/constants';

export const appendClassInNavbarAction = (dispatch: Dispatch, boolValue: boolean) => {
    return dispatch({
        type: APPEND_CLASS_TO_NAV,
        payload: boolValue
    });
};
